export default __webpack_public_path__ + "static/media/AppMobile.b025488d.svg";